import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, FormBuilder, FormArray} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import type { ColDef, SideBarDef, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";

import { logisticaModulo as diccionarios} from '../../logistica-diccionario';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LogisticaService } from '../../service/logistica.services';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';

@Component({
  selector: 'app-marquesinas',
  templateUrl: './marquesinas.component.html',
  styleUrls: ['./marquesinas.component.css']
})
export class MarquesinasComponent implements OnInit {

  public DAT_TITULOS    = diccionarios.titulos.marquesina;
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID    = diccionarios.agGrid;

  public titleModal   : string;
  public loading      : boolean = false;
  public isCreate     : boolean = true;

  // variables para el grid
  public frameworkComponents: any;
  public columnDefs     : ColDef[] = [];
  public defaultColDef  : ColDef;
  public rowData        : any[] = [];
  public rowSelection   : any;
  public gridApi        : any;
  public gridColumnApi  : any;
  public textoBuscar    : string;

  public sideBar        : SideBarDef | string | string[] | boolean | null;

  // variables funcionales
  public fechaHoraIncio : any;
  public formulario: FormGroup;

  constructor(    
    private utilServices    : UtilsService,
    private logisticaAPI    : LogisticaService,
    private _catalogos      : CatalogosLogisticaService,
    private fb              : FormBuilder,
  ) { }

  ngOnInit(): void {
    this.formulario = this.fb.group({
      id        : [''],
      codigo    : ['', [Validators.required, Validators.maxLength(10)]],
      ubicacion : ['', [Validators.required, Validators.maxLength(100)]],
    });

    this.cargarGridcomponent();
    this.listar();
  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };
    this.columnDefs = [
      { field: 'id',        sortable: true },
      { field: 'codigo',    sortable: true },
      { field: 'ubicacion', sortable: true },
      { cellRenderer: 'buttonRenderer', cellRendererParams: {onClick: this.editar.bind(this), label: 'Editar'} },
      { cellRenderer: 'buttonRenderer', cellRendererParams: {onClick: this.eliminar.bind(this), label: 'Eliminar'} },
    ];
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi       = params.api;
    this.gridColumnApi = params.columnApi;  
  }

  listar(){    
    this.rowData = [];
    this.logisticaAPI.getMarquesinas().subscribe((res) => {
      if(res) this.rowData = res;
    }, (err) => { 
      console.log(err.message); 
    });
  }

  nuevo(){
    this.isCreate = true;
    this.titleModal = this.GLOBAL_TITULOS.tituloAgregar;
    this.formulario.reset();
    this.openModal();
  }

  selected = [];
  editar({rowData}) {
    this.isCreate = false;
    this.titleModal = this.GLOBAL_TITULOS.tituloActualizar;
    this.formulario.reset();
    this.formulario.patchValue(rowData);
    this.openModal();
  }

  eliminar({rowData}) {
    const payload  = rowData;
    console.log("payload a eliminar", payload);
    
    this.loading = true;
    this.utilServices.confirmarSincronoPromesa({
        title   : this.GLOBAL_TITULOS.tituloEliminar,
        text    : this.DAT_TITULOS.titulo,
        action  : 'Eliminar',
        funcion : this.logisticaAPI.deleteMarquesina(payload.id)
      }).then(() => {
        this.listar();
        this.closeModal();
      }).catch(() => {});

      this.loading = false;
  }

  saveForm() {
    this.getFormValidationErrors();
    if (this.formulario.invalid) return;

    let mensajeP = this.isCreate ? diccionarios.mensajes.guardar : diccionarios.mensajes.actualizar;
    const payload  = this.formulario.getRawValue();
    console.log("payload", payload);
    
    this.loading = true;
    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.isCreate ? this.logisticaAPI.createMarquesina(payload) : this.logisticaAPI.updateMarquesina(payload)
      }).then(() => {
        this.listar();
        this.closeModal();
      }).catch(() => {});

      this.loading = false;
  }

  acciones(event) {
    if(event === 'regresar') return this.closeModal();
    this.saveForm();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  onKeydown(event) {
    console.log(event);
    if ((event.key === 'Enter' && this.formulario.valid === true)){
        console.log('ENTER --> KEYDOWN');
      }
  }

  getFormValidationErrors() {
    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');
    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
    console.log('Number of errors: ', totalErrors);
  }

}
